var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetsDb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 8H26.6668V26.6667H5.3335V8Z",
    fill: "#353F41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0002 10.6667H8.00016V24H24.0002V10.6667ZM5.3335 8V26.6667H26.6668V8H5.3335Z",
    fill: "#DDDDDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.33331H28V9.33331H4V5.33331Z",
    fill: "#353F41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.33331H29V10.3333H3V4.33331ZM5 6.33331V8.33331H27V6.33331H5Z",
    fill: "#DDDDDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6665 13.3333H13.3332V14.6666H18.6665V13.3333H21.3332V17.3333H10.6665V13.3333Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsDb);
export default __webpack_public_path__ + "static/media/assets_db.2d9951a55d4ca0019a81d9875f9c3248.svg";
export { ForwardRef as ReactComponent };